import { render, staticRenderFns } from "./LunchMenuCategoryListing.vue?vue&type=template&id=1327b7b8&scoped=true&"
import script from "./LunchMenuCategoryListing.vue?vue&type=script&lang=js&"
export * from "./LunchMenuCategoryListing.vue?vue&type=script&lang=js&"
import style0 from "./LunchMenuCategoryListing.vue?vue&type=style&index=0&id=1327b7b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1327b7b8",
  null
  
)

export default component.exports